'use client';
export {
  FocusScope,
  //
  Root,
} from './focus-scope';
export type { FocusScopeProps } from './focus-scope';
